import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { DataUsagesResponse } from '@/shared/types/serviceLineTypes';

// Get Region Usage
export const useRegionUsage = (regionCode: string | undefined, month: string | undefined) => {
  return useQuery({
    queryKey: ['region-usage', regionCode, month],
    queryFn: async () => {
      const response = await apiClient.get<DataUsagesResponse>(
        `/enterprise/v1/usage-summary`,
        { params: { regionCode, month: month ? month : undefined } }
      );
      return response.data;
    },
    enabled: !!regionCode
  });
};